import "./footer.scss";
import DS_FOOTER from "../../../../Assets/images/DS_FOOTER.svg";
import { checkIsStaging } from "../../utils/common";

export default function (props) {
  const { openCallBackModal } = props;

  const footerNavPoints = [
    {
      tag: "Products",
      productList: ["Domains", "Website Themes", "Marketing", "E-Commerce"],
    },
    {
      tag: "Resources",
      productList: ["Help Center"],
    },
  ];
  const handleNavLinkCLick = (inputVal) => {
    if (inputVal === "Help Center") {
      window.location.href = checkIsStaging()
        ? "https://website.digitaldukaan.app/help-section"
        : "https://digitalshowroom.in/help-section";
    } else {
      window.location.href = checkIsStaging()
        ? `https://website.digitaldukaan.app?navTo=${inputVal}`
        : `https://digitalshowroom.in?navTo=${inputVal}`;
    }
  };
  const handleLogoClick = () => {
    if (checkIsStaging()) {
      window.location.href = "https://website.digitaldukaan.app/";
    } else {
      window.location.href = "https://digitalshowroom.in/";
    }
  };
  const renderFooterNavPoints = (id) =>
    footerNavPoints?.map((navData, idx) =>
      id === idx ? 
        <>
          {" "}
          <div className="footer_nav_points" key={idx}>
            <p>{navData?.tag}</p>
            <div className="product_list">
              {navData?.productList?.map((product, idx) => 
                <p key={idx} onClick={() => handleNavLinkCLick(product)}>
                  {" "}
                  {product}
                </p>,
              )}
            </div>
          </div>
        </>
       : null,
    );
  const handleSocialMediaRedirect = (link) => {
    window.open(link, "_blank");
  };

  return (
    <div className="footer_container">
      <div className="footer_top_container">
        <div className="first_col">
          <div className="logo" onClick={handleLogoClick}>
            <img src={DS_FOOTER} className="logo-img" alt="digitalshowroom-logo" loading="lazy" />
          </div>
        </div>
        <div className="second_col">{renderFooterNavPoints(0)}</div>
        <div className="third_col">{renderFooterNavPoints(1)}</div>
        <div className="fourth_col">
          <div className="get_in_touch">
            <p>Get in touch with our experts</p>
            <button onClick={() => openCallBackModal()}>Get a Callback</button>
          </div>
        </div>
      </div>
      <div className="footer_bottom_container">
        <p>© DotPe, All rights reserved</p>
        <div className="icon_container">
          <img
            src="https://cdn.dotpe.in/longtail/themes/76/s5CTn5yg.png"
            alt="twitter-logo"
            onClick={() => handleSocialMediaRedirect("https://x.com/digitalshowrmin?s=21")}
          />
          <img
            src="https://cdn.dotpe.in/longtail/themes/76/xp0HbCZn.png"
            alt="instagram-logo"
            onClick={() =>
              handleSocialMediaRedirect("https://www.instagram.com/digitalshowroomin?igsh=OGQ5ZDc2ODk2ZA==")
            }
          />
          <img
            src="https://cdn.dotpe.in/longtail/themes/76/MKYZFh6E.png"
            alt="yotube-logo"
            onClick={() => handleSocialMediaRedirect("https://www.youtube.com/@DigitalShowroom")}
          />
        </div>
      </div>
    </div>
  );
}
